import { useEffect, useState } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";

// Constants
import {
  TITLE,
  ALL_DYNA_CONTACT_LIST,
  ALL_EVENTS_LIST,
  ABOVE_TITLE,
  ACCENTURE_VIDEO_PAGES,
  ALL_BANNERS,
} from "./WelcomeAccentureConstants";
import { BUTTON_NAME, BUTTON_LINK } from "./WelcomeAccentureConstants";

// Images
import homepageBanner from "../../../assets/img/partnerPortal/homepage.png";
import accenture from "../../../assets/img/partnerPortal/welcomeAccenture/accenture.svg";
import checkmark from "../../../assets/img/partnerPortal/welcomeAccenture/checkmark-small.svg";
import demo_banner from "../../../assets/img/partnerPortal/welcomePage/demoImg.png";

// Scss
import "../../../assets/css/partnerProgram.scss";
import "../../../assets/css/partnerPortal/welcome.scss";

// actions
import * as partnerPortalAction from "../../../actions/partnerPortal/PartnerPortalAction";

import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Image from "react-bootstrap/Image";
import NewsSection from "../../../components/NewsSection";
import Title from "../../../components/Title";
import ButtonOne from "../../../components/ButtonOne";
import ContactSection from "../../../components/ContactSection";
import PartnerCertificationsDTO from "../../../models/PartnerCertificationsDTO";
import { Carousel } from "react-bootstrap";
import VidyardPlayer from "../../../utils/VidyardPlayer";

function WelcomeAccenture() {
  let history = useHistory();
  const [certificationList, setCertificationList] =
    useState<Array<PartnerCertificationsDTO>>();
  const [buttonName, setButtonName] = useState("Show more");

  useEffect(() => {
    canYouHaveAccess();
    //getCertification();
  }, []);

  return (
    <>
      <div>
        <BannerOne
          bannerImage={homepageBanner}
          title={TITLE}
          logo2={accenture}
          aboveTitle={ABOVE_TITLE}
          logoWidth={"100%"}
          buttonName={BUTTON_NAME}
          buttonLink={BUTTON_LINK}
          targetFirstButton="_parent"
          marginTop={"addMarginTop2"}
        />
        <Container className="mt-5">
          <div className="welcomeBanner mb-5">
            <div className="videoStyle">
              <VidyardPlayer uuid="g64nY97HQBJKXkD4DomYaa" type="lightbox" />
            </div>
            <div className="welcomeQuote">
              <div className="quote">
                “The combination of Accenture and Dynatrace together is really
                helping our clients transform faster, more repeatedly with
                scale”
              </div>
              <div className="quoteSign">
                <div className="quoteSignatureGeneral fontWeight700">
                  Scott Wintermute
                </div>
                <div className="quoteSignatureGeneral fontWeight400">
                  Managing Director, Accenture Cloud First
                </div>
              </div>
            </div>
          </div>

          <Row>
            <Col xs={12} sm={12} md={12} lg={8} className="mb-5">
              <Carousel>
                {ALL_BANNERS.map((b) => (
                  <Carousel.Item>
                    <a href={b.link} target={b.target}>
                      <Image src={b.image} width={b.width} />
                    </a>
                  </Carousel.Item>
                ))}
              </Carousel>

              <div>
                <Title className={"mt-5"} title={"WELCOME"} />
                <div className="welcomeMessageSection mt-3">
                  <div className="contactGeneral fontWeight400">
                    Accenture and Dynatrace help companies simplify cloud
                    complexity, enhance performance and ensure reliability.
                    Combining Accenture cloud modernization and transformation
                    services with the Dynatrace unified observability platform,
                    AI and automation, clients around the world realize more
                    value from their applications and infrastructure at speed
                    and scale.
                  </div>
                  <div className="welcomeList">
                    <div className="contactGeneral fontWeight800">
                      Partnership Highlights
                    </div>
                    <div className="welcomeListRow">
                      <img src={checkmark} />
                      <div className="contactGeneral fontWeight400">
                        On November 2, Dynatrace and Accenture announced the
                        evolution of our partnership with Accenture, bringing
                        together the value of the Dynatrace platform with
                        Accenture's global professional services capabilities
                        and cloud modernization delivery experience.
                        <br />
                        <div className="ml-5">
                          Joint GTM partnership with Accenture in NORAM and
                          EMEA.
                        </div>
                        <div className="ml-5">
                          Opportunistic partnership in APAC and LATAM
                        </div>
                      </div>
                    </div>
                    <div className="welcomeListRow">
                      <img src={checkmark} />
                      <div className="contactGeneral fontWeight400">
                        Accenture holds the following certifications globally
                        <br />
                        <div className="ml-5">Associate - 140</div>
                        <div className="ml-5">Professional - 16</div>
                      </div>
                    </div>

                    <div className="welcomeListRow">
                      <img src={checkmark} />
                      <div className="contactGeneral fontWeight400">
                        Accenture is Services Endorsed for Observability in
                        NORAM and EMEA
                      </div>
                    </div>

                    <div className="welcomeListRow">
                      <img src={checkmark} />
                      <div className="contactGeneral fontWeight400">
                        Accenture employees hold Dynatrace certifications in the
                        following areas:
                        <br />
                        <div className="ml-5">
                          Services Delivery Certification - Observability (all
                          GEOs)
                        </div>
                        <div className="ml-5">
                          Services Delivery Certification - CloudOps (NORAM)
                        </div>
                        <div className="ml-5">
                          Services Delivery Certification - SaaS Upgrade (NORAM)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <Title className={"mt-5"} title={"WHAT TO KNOW"} />

                <div className="welcomeList mt-3">
                  <div className="contactGeneral fontWeight800">Videos</div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Dynatrace certification: Real stories from 2 Accenture
                      experts -{" "}
                      <a
                        target="_parent"
                        href="https://partners.dynatrace.com/#/page/accenture-cert-story"
                      >
                        watch now
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight800">Assets</div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Avanade Observability: Powered by Dynatrace on Microsoft
                      Azure -{" "}
                      <a
                        target="_parent"
                        href="https://partners.dynatrace.com/#/collateral/8a9983ce90d6f9a50190dff657f24a91"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight800">Training</div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Learn more about role based training and certifications -{" "}
                      <a
                        target="_parent"
                        href="https://partners.dynatrace.com/#/page/enablement"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      App Developer Certification -{" "}
                      <a
                        target="_parent"
                        href="https://partners.dynatrace.com/#/page/app-developer"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                </div>
              </div>

              <div>
                <Title className={"mt-5"} title={"WHAT TO SHOW"} />

                <div className="welcomeList mt-3">
                  <div className="contactGeneral fontWeight800">
                    Accenture Use Cases
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Liquid Studio Rome -{" "}
                      <a
                        target="_blank"
                        href="https://partners.dynatrace.com/#/collateral/8a9983cf8e1b6d3a018e1de13dbe2f17"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Dynatrace in the Accenture Cloud Innovation Center -{" "}
                      <a
                        target="_blank"
                        href="https://partners.dynatrace.com/#/collateral/8a998a608e12e37a018e1de12f303c74"
                      >
                        read more
                      </a>
                    </li>
                  </div>

                  <div className="contactGeneral fontWeight800">Videos</div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Accenture and Dynatrace: Going beyond observability -{" "}
                      <a
                        target="_blank"
                        href="https://www.dynatrace.com/partners/stories/accenture/"
                      >
                        watch the video
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      The Dynatrace difference -{" "}
                      <a
                        target="_blank"
                        href="https://www.dynatrace.com/company/"
                      >
                        watch the video
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      The Accenture Dynatrace partnership leverages
                      observability, data insights, and a shared ecosystem to
                      deliver significant value to clients facing critical
                      business challenges -{" "}
                      <a
                        target="_blank"
                        href="https://video.dynatrace.com/watch/Yr112wfNq8ub7ffGE32mwd"
                      >
                        watch the video
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Accenture POV on mastering observability for AI-era
                      business transformation -{" "}
                      <a
                        target="_blank"
                        href="https://video.dynatrace.com/watch/PhxE3FcP6qi6ooR9Qq2127"
                      >
                        watch the video
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight800">
                    Client Stories
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      One Financial helps financial service providers worldwide
                      deliver seamless customer experiences with Dynatrace and
                      Accenture -{" "}
                      <a
                        target="_blank"
                        href="https://partners.dynatrace.com/#/collateral/8a99933b911f1a5e0191221c39c232b1"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Santander - Accenture Win -{" "}
                      <a
                        target="_blank"
                        href="https://partners.dynatrace.com/#/collateral/8a998a608e12e37a018e1dd0175e31df"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Accenture leverages Dynatrace for multinational clothing
                      retailer’s digital transformation -{" "}
                      <a
                        target="_blank"
                        href="https://partners.dynatrace.com/content/8a998a608e12e37a018e14c22587538e"
                      >
                        read more
                      </a>
                    </li>
                  </div>

                  <div className="contactGeneral fontWeight800">
                    Thought leadership
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Dynatrace ranked #1 in 6 of 6 Use Cases in 2023 Gartner®
                      Critical Capabilities for APM and Observability report -{" "}
                      <a
                        target="_blank"
                        href="https://www.dynatrace.com/gartner-critical-capabilities-for-application-performance-monitoring-observability/"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Dynatrace named a Leader in the 2023 Gartner MQ for APM &
                      Observability -{" "}
                      <a
                        target="_blank"
                        href="https://www.dynatrace.com/monitoring/gartner-magic-quadrant-for-application-performance-monitoring-observability/"
                      >
                        read more
                      </a>
                    </li>
                  </div>
                  <div className="contactGeneral fontWeight400">
                    <li>
                      Forrester Wave: Dynatrace named a Leader in AIOps -{" "}
                      <a
                        target="_blank"
                        href="https://www.dynatrace.com/info/reports/forrester-aiops-wave-report/"
                      >
                        read more
                      </a>
                    </li>
                  </div>

                  <div className="contactGeneral fontWeight800 mt-3">Demo</div>
                  <div className="cardDemo mt-3">
                    <div className="demoContent">
                      <Title
                        withoutLine={true}
                        classNameText="fontSize18"
                        title={
                          <div>
                            Access our demo<br></br> environment to deliver the
                            <br></br> best presentations to your prospects
                          </div>
                        }
                      />
                      <ButtonOne
                        text={"Learn more"}
                        classNameOfA={"wid45"}
                        className={"pad7"}
                        link={"https://demo.live.dynatrace.com/"}
                        withoutIcon={true}
                      />
                    </div>
                    <img
                      className="demoImgCard"
                      src={demo_banner}
                      width="50%"
                    />
                  </div>
                </div>
              </div>

              {/* <div>
                        <Title className={"mt-5"} title={"Congratulations to our latest experts"}/>
                        {(certificationList == undefined) ? "" : <ExpertsSection partnerCertificationList={certificationList} />}

                    </div> */}
            </Col>
            {/* SECOND COLUMN */}
            <Col xs={12} sm={12} md={12} lg={4}>
              <div className="frameOne">
                <Title
                  title={"Dynatrace Partner Contacts"}
                  className="width100"
                />
                <ContactSection contactList={ALL_DYNA_CONTACT_LIST} />
              </div>
              <div className="frameOne">
                <Title
                  title={"News, webinars & featured events"}
                  className="width100"
                />
                <NewsSection
                  newsList={ALL_EVENTS_LIST}
                  buttonName={buttonName}
                  action={ShowMoreOrLessEvents}
                />
              </div>
              <div className="frameOne mt-3">
                <Title
                  title={"Accenture Observability Hub Programs"}
                  className="width100"
                />
                <small>
                  <b>
                    - Watch recent events or register for upcoming joint
                    Accenture/Dynatrace events
                  </b>
                </small>
                <NewsSection newsList={ACCENTURE_VIDEO_PAGES} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );

  function canYouHaveAccess() {
    try {
      if (
        process.env.REACT_APP_PROTECT_PAGE === "true" &&
        window.top?.location.host !== process.env.REACT_APP_ALLOW_API
      ) {
        console.log("You shall not pass");
        history.push("/not-found");
      }
    } catch (err) {}
  }

  function ShowMoreOrLessEvents() {
    console.log("here");
    setButtonName(buttonName === "Show more" ? "Show less" : "Show more");
    ALL_EVENTS_LIST.forEach((e) => (e.show = !e.show));
  }

  async function getCertification() {
    partnerPortalAction
      .getPartnerCertifications("ACCENTURE", 6)
      .then((response) => {
        setCertificationList(response.data);
      })
      .catch((err) => {
        console.error("certifications not fetch!", err);
      });
  }
}

export default WelcomeAccenture;
